import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { useMediaQuery } from 'react-responsive';
import { Row, Col } from 'reactstrap';
import { Container, NavButtons, NavText, ImageContainer, StyledImage } from './styled';
import {
    CommomContainer, 
    CommomTitle, 
    CommomText,
    CommomImageBanner,
    CommomCentred
} from './styled'


// Importe as imagens usando caminhos relativos à raiz do projeto
const image1 = '/images/Joinkids_apoiador_smilinguido.png';
const image2 = '/images/Joinkids_apoiador_tia_ceceu.png';
const image3 = '/images/Joinkids_apoiador_minha_vida_e_uma_viagem.png';
//const image4 = '/images/Joinkids_apoiador_paodiario.png';
//const image5 = '/images/Joinkids_apoiador_paodiario.png';
const image6 = '/images/Joinkids_apoiador_smilinguido.png';
const image7 = '/images/Joinkids_apoiador_paodiario.png';
const image8 = '/images/Joinkids_apoiador_fingerprint_ministry.png';
const image9 = '/images/Joinkids_apoiador_minha_vida_e_uma_viagem.png';
const image10 = '/images/Joinkids_apoiador_sheepelitos.png';
const image11 = '/images/Joinkids_apoiador_biblianacozinha.png';

const images = [image1, image2, image3, image6, image7, image8, image9, image10, image11];
const Appok = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Função para avançar automaticamente
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
    }, 5000); // Mudar a cada 5 segundos

    return () => clearInterval(interval);
  }, []);

  // Verifica se a tela é grande (acima de 1024px)
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1024px)',
  });

  // Verifica se a tela é pequena (abaixo de 1024px)
  const isMobile = useMediaQuery({
    query: '(max-width: 1024px)',
  });

  // Define quantas imagens mostrar de acordo com o tamanho da tela
  const slidesToShow = isDesktopOrLaptop ? 4 : 1.5;
  const slideWidthPercentage = isDesktopOrLaptop ? 25 : 66.67; // 25% para 4 imagens e 66.67% para 1.5 imagens

  return (
    <Container>
         {/*<Row>*/}
                       <Col md={{size:6}}>
                            <CommomCentred spaced>
                                <CommomTitle>Apoiado por Marcas que você confia</CommomTitle>
                                <CommomText>A JoinKids agradece o apoio dessas empresas parceiras: Smilinguido, Pão Diário Kids, Minha Vida é uma Viagem, Tia Ceceu, Fingerprint Ministery, Sheepelitos, Leo e Lully, Bíblia na Cozinha, Play com o Pai e Paistores.org</CommomText>
                                
                            </CommomCentred>
                        </Col>
        {/*</Row> */}
        {/* <h1>Bem-vindo ao Nosso Carrossel</h1>
        <p>Deslize para ver nossas imagens, com exibição automática de novas imagens a cada 5 segundos.</p>
 */}
      <Carousel
        selectedItem={activeIndex}
        onChange={(index) => setActiveIndex(index)}
        showThumbs={false}
        showArrows={true}
        autoPlay={true}
        infiniteLoop={true}
        interval={5000}
        emulateTouch={true}
        showStatus={false}
        swipeable={true}
        centerMode={true}
        centerSlidePercentage={slideWidthPercentage} // // Ajusta conforme o tamanho da tela
        showIndicators={true}
      >
        {images.map((src, index) => (
          <ImageContainer key={index}>
            <StyledImage src={src} alt={`Image ${index + 1}`} />
          </ImageContainer>
        ))}
      </Carousel>
      {/* <NavButtons>
        <button onClick={() => setActiveIndex((prevIndex) => (prevIndex === 0 ? images.length - 4 : prevIndex - 1))}>
          <NavText>{'<'}</NavText>
        </button>
        <button onClick={() => setActiveIndex((prevIndex) => (prevIndex === images.length - 4 ? 0 : prevIndex + 1))}>
          <NavText>{'>'}</NavText>
        </button>
      </NavButtons> */}
      
    </Container>
  );
};

export default Appok;
